/* TheSalonGuy homepage v2 — tabs, before/after, quick add */
(function () {
  if (window.__tsgv2) return;
  window.__tsgv2 = true;

  /* Fix finder tabs */
  function initTabs(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* Before / after slider */
  function initCompare(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var range = root.querySelector('input[type="range"]');
    if (!range) return;
    var set = function () { root.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', set);
    set();
  }

  /* Quick add */
  function refreshCart(cart) {
    var d = document.documentElement;
    ['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      d.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    });
    document.querySelectorAll('[data-cart-count], .cart-count, cart-count').forEach(function (el) {
      if (cart && typeof cart.item_count === 'number') el.textContent = cart.item_count;
    });
    var drawer = document.querySelector('cart-drawer, #cart-drawer, [id*="CartDrawer"]');
    if (drawer) {
      if (typeof drawer.show === 'function') drawer.show();
      else if (typeof drawer.open === 'function') drawer.open();
      else drawer.setAttribute('open', '');
      return true;
    }
    return false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-tsgv2-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var id = form.querySelector('[name="id"]').value;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.classList.add('is-added');
        btn.textContent = 'Added to cart';
        if (!refreshCart(cart)) { window.location.href = '/cart'; return; }
        setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; btn.disabled = false; }, 2200);
      })
      .catch(function () { form.submit(); });
  });

  /* Klaviyo inline signup */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.tsgv2-signup__form');
    if (!form) return;
    e.preventDefault();
    var root = form.closest('[data-tsgv2-signup]');
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector('.tsgv2-signup__msg');
    var btn = form.querySelector('button');
    var email = (input.value || '').trim();
    msg.classList.remove('is-error');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Enter a valid email address, like name@example.com.';
      msg.classList.add('is-error');
      input.focus();
      return;
    }
    btn.disabled = true;
    msg.textContent = 'Signing you up…';
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: root.dataset.source || 'Homepage',
        profile: { data: { type: 'profile', attributes: { email: email, properties: { signup_source: root.dataset.source || 'Homepage' } } } }
      }, relationships: { list: { data: { type: 'list', id: root.dataset.list } } } } })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('subscribe');
        form.hidden = true;
        var done = root.querySelector('.tsgv2-signup__done');
        done.hidden = false;
        var link = done.querySelector('a');
        if (link) link.focus();
      })
      .catch(function () {
        btn.disabled = false;
        msg.textContent = "That didn't go through. Check your connection and try again.";
        msg.classList.add('is-error');
      });
  });

  function boot() {
    document.querySelectorAll('[data-tsgv2-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-tsgv2-compare]').forEach(initCompare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
